// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Transactions = [
  {
    title: 'Assign Inspection',
    path: '/dashboard/transactions/assignInspection',
    icon: icon('company', 'png'),
    ShortName: 'AssignInspection_Transaction',
  }, 
  {
    title: 'Inspections',
    path: '/dashboard/transactions/Inspections',
    icon: icon('company', 'png'),
    ShortName: 'Inspections_Transaction',
  }, 
  {
    title: 'Inspection Tracker',
    path: '/dashboard/transactions/inspectionTracker',
    icon: icon('company', 'png'),
    ShortName: 'InspectionTracker_Transaction',
  }, 
  
  {
    title: 'Fabric Inspection',
    path: '/dashboard/transactions/Fabricinspections',
    icon: icon('company', 'png'),
    ShortName: 'FabricInspection_Transaction',
  },
  {
    title: 'Fabric Inspection Tracker',
    path: '/dashboard/transactions/FabricinspectionTracker',
    icon: icon('company', 'png'),
    ShortName: 'FabricInspectionTracker_Transaction',
  },
  
];

export default Transactions;
